<template>  
  <div id="result" v-if="loaded">   
    <transition name="fadeRight" mode="out-in" appear>    
      <div id="robotContainer" v-if="isResult"> 
        <img id="robot" :src="robotImage"/> 
      </div>
    </transition>
    <transition name="fadeRight" mode="out-in" appear>    
      <div :key="isResult" v-if="isResult" id="resultsContainer" >
        <div id="results" >
          <div class="resultPart" v-bind:class="{ 'single' : results.length == 1 }" v-for="(result, index) in results" :key="result+index">
          <p v-if="results.length > 1">{{index + 1}}. Auftrag: {{bonNames[index]}}</p>
          <div class="container" v-for="(value, i) in result" :key="result+i">
              <div v-if="results.length == 1">
                  <p v-if="i == result.length - 1">Ausschuss</p>
                  <p v-else>Pfefferminz&#8203;bonbons</p>
              </div>
              <img class="car" :src="imageContainer"/>
              <img class="bon" v-if="i == result.length - 1" :src="failImage"/>
              <div class="bon" v-else-if="bonsData[Math.max(0, results.length - (i - index + 2))]" v-html="replaceColors(bonsData[Math.max(0, results.length - (i - index + 2))][1], Math.max(0, results.length - (i - index + 2)))"></div>
              <span>{{value}}</span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import eventBus from "../eventBus";
import Velocity from "velocity-animate";

export default {
  name: "result",
  props: ["isResult", "results", "bonsData"],
  data() {
    return {
      loaded: false,
      bonNames: [],
      imageContainer: "",
      robotImage: "",
      failImage: "",
    };
  },
  created() {
    this.imageContainer = window.dataPath + "image/resultcontainer.svg";
    this.robotImage = window.dataPath + "image/robot.svg";
    this.failImage = window.dataPath + "image/bonbons/fail.svg";
    this.bonNames = window.bonNames;
    this.fetchData(() => ( this.loaded = true ));
    eventBus.$on("hideRobot", this.hideRobot);
  },
  beforeDestroy() {
    this.clearData();
    eventBus.$off("hideRobot", this.hideRobot);
  },
  methods: {
    fetchData(callback) {
      if (callback) callback();
    },
    clearData() {
      this.bonName = [];
      this.imageContainer = "";
      this.robotImage = "";
      this.failImage = "";
    },
    replaceColors(svg, combinatorIndex) {
        if (window.combinators.length <= 0) return;
        if (combinatorIndex > window.combinators.length - 1) 
            combinatorIndex = window.combinators.length - 1;  
        var combination = window.combinators[combinatorIndex].currentCombination;
        for (var i = 0; i < combination.length; i++) {
            let index = parseInt(combination[i]) - 1;
            svg = svg.split(('#color' + (i + 1))).join(colors[index]);
        }
        return svg;
    },
    hideRobot() {
      var robot = document.getElementById("robot")
      robot.classList.add("hidden");
    },
    clearData() {
      this.imageContainer = '';
    }
  }
};
</script>

<style lang="scss">
@import "../style/animate.css";
@import "../style/transitions.scss";
@import "../style/basic.scss";

#result {
    position: absolute;
    float: left;
    top: 150px;
    height: calc(100% - 300px);
    left: 0%;
    width: 100%;
    z-index: 5;
    overflow: hidden;

    #robotContainer
    {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;

      #robot {
        position: absolute;
        display: inline-block;
        top: 0;

        height: 100%;

        left: 52.5%;
        transition: all 0.5s;
        
        &.hidden {
          left: 120%;
        }
      }
    } 

    #resultsContainer {
      width: 100%;
      height: 100%;
    }

    #results {
      position: relative;
      bottom: 0;
      top: 80%;
      left: 50%;
      float: left;
      transform: translateX(-50%);
    }

    .resultPart {
      position: relative;
      display:inline-block;
      float: right;
      top: 80%;
      height: 20%;


      &:not(:first-child) {
        margin-right: 50px;
      }

      p {
        position: absolute;
        width: 150%;
        left: -25%;
        font-family: "DINPro-Bold", sans-serif;
        height: 50px;
        line-height: 50px;
        margin-top: -50px;
        text-align: center;
      }

      .container {
        width: auto;
        float: left;
        height: 100%;
        width: auto;
        position: relative;

        p {
          position: absolute;
          top: -10%;      
          width: 150%;
          left: -25%;
          text-align: center;
          line-height: 24px;
        }

        img.car {
          display: block;
          height: 100%;
          margin-left: auto;
          margin-right: auto;
        }

        .bon {
            position: absolute;
            top: 23.15%;
            height: 22%;
            left: 50%;
            transform: translateX(-50%);
            svg {
              height: 100%;
            }
        }

        &:not(:first-of-type) {
          margin-left: 30px; 
        }
        
        span {
          font-family: "DINPro-Bold", sans-serif;
          position: absolute;
          top: 45%;
          line-height: 50px;
          left: calc(50% - 25px);
          width: 50px;
          text-align: center;
          color: #1b181c;
        }
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Result.vue